var path = '/pages/picklists/views/contacts/add-contact-modal.tpl.html';
var html = "<button class=\"close\" ng-click=\"picklist.cancel()\"><i class=\"fal fa-times\"></i></button>\n<div class=\"modal-header\">\n    <h2>{{'picklists.add_contact_details' | i18n}}</h2>\n</div>\n<div class=\"modal-body\">\n    <editor model=\"picklist.model\" schema=\"picklist.schema\" form=\"picklist.form\" on-save=\"picklist.save(model)\" on-cancel=\"picklist.cancel()\"></editor>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/picklists/views/contacts/add-contact-modal.tpl.html
// module id = 2298
// module chunks = 1